import { veteranFields } from '../definitions/constants';

const parseYear = value => {
  if (typeof value !== 'string') {
    return null;
  }

  const match = value.match(/^(\d{4})/);
  return match ? Number(match[1]) : null;
};

export const getVeteranDobYear = formData => {
  const dob =
    formData?.[veteranFields.parentObject]?.[veteranFields.dateOfBirth];
  return parseYear(dob);
};

export const DOB_DATE_VALIDATION_FLAG = 'form218940DobDateValidation';

export const shouldUseDobDateValidation = formData =>
  !!formData?.[DOB_DATE_VALIDATION_FLAG];

export const validateNotOnOrBeforeDOB =
  errorMessage => (errors, fieldData, formData) => {
    if (!shouldUseDobDateValidation(formData)) {
      return;
    }

    const dobYear = getVeteranDobYear(formData);
    const eventYear = parseYear(fieldData);

    if (dobYear && eventYear && eventYear <= dobYear) {
      errors.addError(errorMessage);
    }
  };

export const withDobValidation = (fieldUi, errorMessage) => ({
  ...fieldUi,
  'ui:validations': [
    ...(fieldUi?.['ui:validations'] || []),
    validateNotOnOrBeforeDOB(errorMessage),
  ],
});
